var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsFunds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -1038.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Funds",
    transform: "translate(5026.000000, 1038.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,18 L23,18 C21.896,18 21,17.104 21,16 L21,13 L24,13 C25.104,13 26,13.896 26,15 L26,18 Z M26,25 L23,25 C21.896,25 21,24.104 21,23 L21,20 L24,20 C25.104,20 26,20.896 26,22 L26,25 Z M19,18 L16,18 C14.896,18 14,17.104 14,16 L14,13 L17,13 C18.104,13 19,13.896 19,15 L19,18 Z M19,25 L16,25 C14.896,25 14,24.104 14,23 L14,20 L17,20 C18.104,20 19,20.896 19,22 L19,25 Z M12,18 L9,18 C7.896,18 7,17.104 7,16 L7,13 L10,13 C11.104,13 12,13.896 12,15 L12,18 Z M12,25 L9,25 C7.896,25 7,24.104 7,23 L7,20 L10,20 C11.104,20 12,20.896 12,22 L12,25 Z M28,7 L14,7 L10,2 L0,2 L0,27 C0,29.209 1.791,31 4,31 L32,31 L32,11 C32,8.791 30.209,7 28,7 L28,7 Z",
    id: 25
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsFunds);
export default __webpack_public_path__ + "static/media/investments-funds.97592397.svg";
export { ForwardRef as ReactComponent };